import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MovimientoCaja } from '@p-p-portafolio/interfaces/movimientoCaja';
import { SwalService } from '@shared/utils/swal.service';
import { MovimientoCajaService } from '@p-p-portafolio/services/movimientoCaja.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { CampoTablaWhereService } from '@shared/services/campo-tabla-where.service';
import { MatDialog } from '@angular/material/dialog';
import { AbcEmpresasCustomizablesComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-customizables/abc-empresas-customizables.component';

@Component({
  selector: 'app-movimientoCaja-form',
  templateUrl: './movimientoCaja-form.component.html',
  styleUrls: ['./movimientoCaja-form.component.css']
})
export class MovimientoCajaFormComponent implements OnInit {
  loading: boolean = false;
  model: MovimientoCaja | null = null;
  monedas: any[] = [];
  tipoTrans: any[] = [];
  formPrincipal: boolean = true;
  selectMoneda: boolean = false;

  form = this._fb.group({
    iOrigen: [0, [Validators.required]],
    sDescripcion: ['', [Validators.required]],
    moneda: ['', [Validators.required]],
    iTipoTrans: [0, [Validators.required]],
    iAutorizacion: [0, [Validators.required]]
  });

  constructor(
    private _fb: UntypedFormBuilder,
    private movimientoCajaService: MovimientoCajaService,
    private swalService: SwalService,
    private dialogRef: MatDialogRef<MovimientoCajaFormComponent>,
    private ctwServices: CampoTablaWhereService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: MovimientoCaja
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.setForm();
    }
    this.readMonedas();
    this.readTipoTrans();
  }

  setForm(): void {
    if (this.data) {
      this.model = { ...this.data };
      this.form.patchValue({
        iOrigen: +this.data.iOrigen,
        sDescripcion: this.data.sDescripcion,
        moneda: this.data.moneda,
        iTipoTrans: +this.data.iTipoTrans,
        iAutorizacion: +this.data.iAutorizacion
      });
      this.form.controls["iOrigen"].disable();
    } else {
      this.form.reset();
      this.form.controls["iOrigen"].enable();
    }
  }

  readMonedas(): void {
    this.ctwServices.monedas().subscribe({
      next: (response) => {
        if (response.data) {
          this.monedas = response.data;
        }
      },
      error: (error) => {
        this.swalService.error('Error al cargar las monedas');
      }
    });
  }

  readTipoTrans(): void {
    this.movimientoCajaService.readTipoTrans().subscribe({
      next: (response) => {
        if (response.data) {
          this.tipoTrans = response.data;
        }
      },
      error: (error) => {
        this.swalService.error('Error al cargar los tipos de transacción');
      }
    });
  }

  changeBoolean(change: string): void {
    switch (change) {
      case 'form':
        this.selectMoneda = false;
        this.formPrincipal = true;
        break;
      case 'moneda':
        this.formPrincipal = false;
        this.selectMoneda = true;
        break;
    }
  }

  create(model: any) {
    if (this.form.valid) {
      this.loading = true;
      const movimientoCaja: MovimientoCaja = {
        ...model,
        iOrigen: +model.iOrigen,
        iTipoTrans: +model.iTipoTrans,
        iAutorizacion: +model.iAutorizacion
      };

      this.movimientoCajaService.create(movimientoCaja).subscribe({
        next: (res) => {
          if (res.exito === 1) {
            this.swalService.success('Movimiento de caja agregado correctamente');
            this.dialogRef.close(true);
          } else {
            this.swalService.error('No se pudo agregar el movimiento de caja');
          }
          this.loading = false;
        },
        error: (error) => {
          this.swalService.error(error);
          this.loading = false;
        }
      });
    }
  }

  update(model: any) {
    if (this.form.valid) {
      this.loading = true;
      const movimientoCaja: MovimientoCaja = {
        ...model,
        iOrigen: this.model?.iOrigen || 0,
        iTipoTrans: +model.iTipoTrans,
        iAutorizacion: +model.iAutorizacion
      };

      this.movimientoCajaService.update(movimientoCaja).subscribe({
        next: (res) => {
          if (res.exito === 1) {
            this.swalService.success('Movimiento de caja actualizado correctamente');
            this.dialogRef.close(true);
          } else {
            this.swalService.error('No se pudo actualizar el movimiento de caja');
          }
          this.loading = false;
        },
        error: (error) => {
          this.swalService.error(error);
          this.loading = false;
        }
      });
    }
  }

  openCustomizables(): void {
    const dialogRef = this.dialog.open(AbcEmpresasCustomizablesComponent, {
      width: "1000px",
      height: "1000px",
      disableClose: true,
      panelClass: ["custom-dialog-zindex"],
      hasBackdrop: true,
      autoFocus: false,
      data: {
        sTabla: "catbl_origenes",
        sClave: `${this.model?.iOrigen}`,
        sNombre: this.model?.sDescripcion || '',
        sTipo: "Opcion"
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
